<section id="content">
    <div class="page page-profile">
  
      <!-- page header -->
      <div class="pageheader">
        <h2>Installation List</h2>
        <div class="page-bar">
          <ul class="page-breadcrumb">
            <li>
              <a [routerLink]="'/super/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
                {{AppSettings.SITE_TITLE | titlecase}}</a>
            </li>
            <li>
              <a [routerLink]="'/super/'+AppFrontRoutes.INSTALLATION_LIST">Installation List</a>
            </li>
          </ul>
        </div>
      </div>
  
      <!-- page content -->
      <div class="pagecontent">
  
        <!-- row -->
        <div class="row">
            <div class="col-md-12">
                <!-- tile -->
                <section class="tile tile-simple">
        
                    <!-- tile body -->
                    <div class="tile-body p-0">
        
                        <div role="tabpanel">
                            <div class="tab-content">
        
                                <div role="tabpanel" class="tab-pane active" id="generalTab">
        
                                    <div class="wrap-reset">
                                        <form [formGroup]="mailConfigForm" (ngSubmit)="onSubmit()" class="form-validation">
                                            <div class="row">
                                                
                                                <!-- deadline -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Deadlines</label>
                                                    </div>                                                         
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="deadline"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.deadline, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.deadline?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.deadline?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>

                                                <!-- servicing -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Servicing</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="servicing"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.servicing, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.servicing?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.servicing?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- hr_courses -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">HR Courses</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="hr_courses"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.hr_courses, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.hr_courses?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.hr_courses?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- hr_notification -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">HR Notification</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="hr_notification"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.hr_notification, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.hr_notification?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.hr_notification?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- hr_visit -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">HR Visit</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="hr_visit"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.hr_visit, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.hr_visit?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.hr_visit?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- measurement_tools -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Measurement Tools</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="measurement_tools"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.measurement_tools, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.measurement_tools?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.measurement_tools?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- problem_solving -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Problem Solving</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="problem_solving"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.problem_solving, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.problem_solving?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.problem_solving?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- document_management -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Document Management</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="document_management"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.document_management, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.document_management?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.document_management?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- customers -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Customers</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="customers"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.customers, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.customers?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.customers?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- consultancy -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Consultancy</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="consultancy"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.consultancy, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.consultancy?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.consultancy?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- academy -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Academy</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="academy"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.academy, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.academy?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.academy?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <!-- project -->
                                                <div class="form-group col-sm-12">
                                                    <div class="form-group col-sm-2">
                                                        <label for="first-name">Project</label>
                                                    </div>                                                                                   
                                                    <div class="form-group col-sm-4">
                                                    <input type="text" class="form-control" formControlName="project"
                                                    [ngClass]="formErrorClass(mailConfigForm.controls.project, mailConfigFormSubmitted)">
                                                    <span class="text-danger"
                                                    *ngIf="(mailConfigForm.controls.project?.touched || mailConfigFormSubmitted) && mailConfigForm.controls.project?.errors?.required">
                                                    This field is required.
                                                    </span>
                                                    </div>
                                                </div>    
                                                
                                                <div class="form-group col-sm-6">
                                                    <button type="submit" class="btn btn-primary">Submit</button>
                                                  </div>
                                                                                            

                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
  
      </div>
    </div>
  </section>
  
  